import _ from 'lodash'

export const optionsJours = {
  data() {
    return {
      optionsJours: [
        {id: 1, nom: 'Lundi', nomCourt: "Lun."},
        {id: 2, nom: 'Mardi', nomCourt: "Mar."},
        {id: 3, nom: 'Mercredi', nomCourt: "Mer."},
        {id: 4, nom: 'Jeudi', nomCourt: "Jeu."},
        {id: 5, nom: 'Vendredi', nomCourt: "Ven."},
        {id: 6, nom: 'Samedi', nomCourt: "Sam."},
        {id: 0, nom: 'Dimanche', nomCourt: "Dim."},
      ]
    }
  }
}

export const effectifsLieuConsommation = {
  methods: {
    // detailVersRecap(details) {
    //   let recap = []
    //   let typesConvives = [...new Set(details.map(d => d.typeConviveId))]
    //   typesConvives.forEach(tc => {
    //     let typeConvive = { typeConviveId: tc, effectifs: [] }
    //     recap.push(typeConvive)

    //     let detailsTypeConvive = details?.filter(d => d.typeConviveId == tc) || []
    //     detailsTypeConvive.forEach(dtc => {
    //       if (!typeConvive.effectifs.find(e => e.structureMenuId === dtc.structureMenuId && e.typeServiceId === dtc.typeServiceId && e.typeRegimeId === dtc.typeRegimeId && e.typeTextureId === dtc.typeTextureId)) {
    //         dtc.effectifs = detailsTypeConvive.filter(d => d.structureMenuId === dtc.structureMenuId && d.typeServiceId === dtc.typeServiceId && d.typeRegimeId === dtc.typeRegimeId && d.typeTextureId === dtc.typeTextureId)?.map(d => d.effectifs)?.reduce((total, current) => total + current, 0) || 0
    //         typeConvive.effectifs.push(dtc)
    //       }
    //     })
    //   })
    //   return recap
    // },
    detailVersRecap(details, pourEdition) {
      let recap = []

      _.cloneDeep(details)?.forEach(d => {
        if (!recap.find(r => r.typeConviveId === d.typeConviveId && r.structureMenuId === d.structureMenuId && r.typeServiceId === d.typeServiceId && r.typeRegimeId === d.typeRegimeId && r.typeTextureId === d.typeTextureId)) {
          d.detailsEffectifs = details.filter(x => x.typeConviveId === d.typeConviveId && x.structureMenuId === d.structureMenuId && x.typeServiceId === d.typeServiceId && x.typeRegimeId === d.typeRegimeId && x.typeTextureId === d.typeTextureId) || []
          
          // d.effectifs = d.detailsEffectifs.map(x => Math.max(...[x.effectifsLundi, x.effectifsMardi, x.effectifsMercredi, x.effectifsJeudi, x.effectifsVendredi, x.effectifsSamedi, x.effectifsDimanche]))
          //   ?.reduce((total, current) => Math.max(total, current), 0) || 0
          this.effectifsChangentRecap(d)

          if (pourEdition) {
            d.structureChoisie = { id: d.structureMenuId, nom: d.nomStructureMenu }
            d.typeServiceChoisi = { id: d.typeServiceId, nom: d.nomTypeService }
            d.typeRegimeChoisi = { id: d.typeRegimeId, nom: d.nomTypeRegime }
            d.typeTextureChoisi = { id: d.typeTextureId, nom: d.nomTypeTexture }
          }
          recap.push(d)
        }
      })

      return recap
    },
    recapChangeJour(detailsEffectifs, recapEffectifs, optionJour, joursConsommation) {
      let jour = optionJour.id
      let nomJour = "effectifs" + (optionJour.nom ?? "")
      if (joursConsommation.find(j => j === jour)) {
        let alimenterEffectifs = !detailsEffectifs.some(d => d[nomJour])
        detailsEffectifs.forEach(d => {
          if (alimenterEffectifs) {
            // On renseigne les effectifs seulement s'ils n'étaient pas déjà renseigné auparavant afin de ne pas écraser accidentellement les effectifs détaillés qui auraient été modifiés à la main
            let effectifs = recapEffectifs.find(r => r.typeConviveId === d.typeConviveId && r.structureMenuId === d.structureMenuId && r.typeServiceId === d.typeServiceId && r.typeRegimeId === d.typeRegimeId && r.typeTextureId === d.typeTextureId)?.effectifs
            d[nomJour] = effectifs
          }
          if (!d.joursConsommation.find(j => j === jour)) {
            d.joursConsommation.push(jour)
          }
        })
      } else {
        detailsEffectifs.forEach(d => {
          if (d.joursConsommation.find(j => j === jour)) {
            _.remove(d.joursConsommation, j => j === jour)
          }
        })
      }
    },
    recapChangeTypeConvive(recapEffectifs) {
      recapEffectifs.detailsEffectifs?.forEach(e => {
        e.typeConviveId = recapEffectifs.typeConviveId
      })
    },
    recapChangeCategorie(recapEffectifs, structures) {
      let structure = structures?.find(s => s.id === recapEffectifs.structureMenuId)
      let service = structure?.services.find(s => s.typeServiceId === recapEffectifs.typeServiceId)
      let composantes = service?.structureComposantes.filter(c => c.typeRegimeId === recapEffectifs.typeRegimeId && c.typeTextureId === recapEffectifs.typeTextureId) || []

      recapEffectifs.detailsEffectifs = []
      composantes.forEach(c => {
        let eff = {
          typeConviveId: recapEffectifs.typeConviveId,
          structureMenuId: structure.structureMenuId,
          typeServiceId: service.typeServiceId,
          typeRegimeId: c.typeRegimeId,
          typeTextureId: c.typeTexture.id,
          typeComposanteId: c.typeComposanteId,
          structureMenuComposanteId: c.id,
          nomTypeConvive: recapEffectifs.nomTypeConvive,
          indexStructureMenuComposante: c.index,
          nomStructureMenuComposante: c.nomStructureMenuComposante,
          nomStructureMenu: structure.nom,
          nomTypeService: service.nom,
          nomTypeRegime: c.nomTypeRegime,
          nomTypeTexture: c.nomTypeTexture,
          effectifsLundi: null,
          effectifsMardi: null,
          effectifsMercredi: null,
          effectifsJeudi: null,
          effectifsVendredi: null,
          effectifsSamedi: null,
          effectifsDimanche: null
        }
        recapEffectifs.detailsEffectifs.push(eff)
      })
      this.optionsJours.forEach(j => {
        this.recapChangeJour(recapEffectifs.detailsEffectifs, recapEffectifs, j, recapEffectifs.joursConsommation)
      })
      // recapEffectifs.detailsEffectifs?.forEach(e => {
      //   e.structureMenuId = recapEffectifs.structureMenuId
      //   e.typeServiceId = recapEffectifs.typeServiceId
      //   e.typeRegimeId = recapEffectifs.typeRegimeId
      //   e.typeTextureId = recapEffectifs.typeTextureId
      // })
    },
    recapChangeEffectifs(recapEffectifs) {
      recapEffectifs.detailsEffectifs?.forEach(e => {
        let nbComposantesIdentiques = recapEffectifs.detailsEffectifs.filter(d => d.typeComposanteId === e.typeComposanteId).length
        let nbEffectifs = recapEffectifs.effectifs / nbComposantesIdentiques
        e.effectifsLundi = nbEffectifs
        e.effectifsMardi = nbEffectifs
        e.effectifsMercredi = nbEffectifs
        e.effectifsJeudi = nbEffectifs
        e.effectifsVendredi = nbEffectifs
        e.effectifsSamedi = nbEffectifs
        e.effectifsDimanche = nbEffectifs
      })
    },
    effectifsChangentRecap(recapEffectifs) {
      let nbEffectifs = 0
      let typesComposantesIds = [...new Set(recapEffectifs.detailsEffectifs?.map(d => d.typeComposanteId) ?? [])]
      typesComposantesIds.forEach(tc => {
        let effectifs = recapEffectifs.detailsEffectifs?.filter(d => d.typeComposanteId === tc)
          ?.map(x => Math.max(...[x.effectifsLundi, x.effectifsMardi, x.effectifsMercredi, x.effectifsJeudi, x.effectifsVendredi, x.effectifsSamedi, x.effectifsDimanche]))
          ?.reduce((t, c) => t + c, 0) || 0
        
        if (effectifs > nbEffectifs) {
          nbEffectifs = effectifs
        }
      })
      recapEffectifs.effectifs = nbEffectifs
    },


    // recapChangeTypeConvive(detailsEffectifs, recapEffectifs, nouveauTypeConviveId) {
    //   let typesConvives = [...new Set(recapEffectifs.map(r => r.typeConviveId))]
    //   let effectifs = detailsEffectifs.filter(d => !typesConvives.some(tc => tc === d.typeConviveId))
    //   effectifs.forEach(d => {
    //     // On affecte le type de convive sélectionné aux effectifs correspondants
    //     d.typeConviveId = nouveauTypeConviveId
    //   })
    // },
    recapChangeStructureMenu(detailsEffectifs, recapEffectifs, typeConviveId, typeServiceId, typeRegimeId, typeTextureId, nouveauStructureMenuId) {
      let structuresMenusIds = [...new Set(recapEffectifs.filter(r => r.typeConviveId === typeConviveId && r.typeServiceId === typeServiceId && r.typeRegimeId === typeRegimeId && r.typeTextureId === typeTextureId).map(r => r.structureMenuId))]
      let effectifs = detailsEffectifs.filter(d => d.typeConviveId === typeConviveId && d.typeServiceId === typeServiceId && d.typeRegimeId === typeRegimeId && d.typeTextureId === typeTextureId && !structuresMenusIds.some(tc => tc === d.structureMenuId))
      effectifs.forEach(d => {
        // On affecte la structure de menu sélectionnés aux effectifs correspondants
        d.structureMenuId = nouveauStructureMenuId
      })
    },
    recapChangeTypeService(detailsEffectifs, recapEffectifs, typeConviveId, structureMenuId, typeRegimeId, typeTextureId, nouveauTypeServiceId) {
      let typesServicesIds = [...new Set(recapEffectifs.filter(r => r.typeConviveId === typeConviveId && r.structureMenuId === structureMenuId && r.typeRegimeId === typeRegimeId && r.typeTextureId === typeTextureId).map(r => r.typeServiceId))]
      let effectifs = detailsEffectifs.filter(d => d.typeConviveId === typeConviveId && d.structureMenuId === structureMenuId && d.typeRegimeId === typeRegimeId && d.typeTextureId === typeTextureId && !typesServicesIds.some(tc => tc === d.typeServiceId))
      effectifs.forEach(d => {
        // On affecte le type de service sélectionné aux effectifs correspondants
        d.typeServiceId = nouveauTypeServiceId
      })
    },
    recapChangeTypeRegime(detailsEffectifs, recapEffectifs, typeConviveId, structureMenuId, typeServiceId, typeTextureId, nouveauTypeRegimeId) {
      let typesRegimesIds = [...new Set(recapEffectifs.filter(r => r.typeConviveId === typeConviveId && r.structureMenuId === structureMenuId && r.typeServiceId === typeServiceId && r.typeTextureId === typeTextureId).map(r => r.typeRegimeId))]
      let effectifs = detailsEffectifs.filter(d => d.typeConviveId === typeConviveId && d.structureMenuId === structureMenuId && d.typeServiceId === typeServiceId && d.typeTextureId === typeTextureId && !typesRegimesIds.some(tc => tc === d.typeRegimeId))
      effectifs.forEach(d => {
        // On affecte le type de régime sélectionné aux effectifs correspondants
        d.typeRegimeId = nouveauTypeRegimeId
      })
    },
    recapChangeTypeTexture(detailsEffectifs, recapEffectifs, typeConviveId, structureMenuId, typeServiceId, typeRegimeId, nouveauTypeTextureId) {
      let typesTexturesIds = [...new Set(recapEffectifs.filter(r => r.typeConviveId === typeConviveId && r.structureMenuId === structureMenuId && r.typeServiceId === typeServiceId && r.typeRegimeId === typeRegimeId).map(r => r.typeTextureId))]
      let effectifs = detailsEffectifs.filter(d => d.typeConviveId === typeConviveId && d.structureMenuId === structureMenuId && d.typeServiceId === typeServiceId && d.typeRegimeId === typeRegimeId && !typesTexturesIds.some(tc => tc === d.typeTextureId))
      effectifs.forEach(d => {
        // On affecte le type de texture sélectionné aux effectifs correspondants
        d.typeTextureId = nouveauTypeTextureId
      })
    },
    recapChangeNbEffectifs(detailsEffectifs, typeConviveId, structureMenuId, typeServiceId, typeRegimeId, typeTextureId, nouveauNbEffectifs) {
      let effectifs = detailsEffectifs.filter(d => d.typeConviveId === typeConviveId && d.structureMenuId === structureMenuId && d.typeServiceId === typeServiceId && d.typeRegimeId === typeRegimeId && d.typeTextureId === typeTextureId)
      effectifs.forEach(d => {
        // On affecte les effectifs saisis aux effectifs correspondants
        optionsJours.forEach(j => {
          if (d.joursConsommation.find(jc => jc === j.id)) {
            d["effectifs" + (j.nom ?? "")] = nouveauNbEffectifs
          }
        })
      })
    },
    // recapChangeTypeConvive(detailsEffectifs, ancienTypeConviveId, nouveauTypeConviveId) {
    //   let effectifs = detailsEffectifs.filter(d => d.typeConviveId === ancienTypeConviveId)
    //   effectifs.forEach(d => {
    //     // On affecte le type de convive sélectionné aux effectifs correspondants
    //     d.typeConviveId = nouveauTypeConviveId
    //   })
    // },
    recapChangeConf(detailsEffectifs, joursConsommation, ancienneConf, nouvelleConf) {
      let anciensEffectifs = null
      let nouveauxEffectifs = null
      if (ancienneConf) {
        // Ajout d'une nouvelle configuration
        anciensEffectifs = detailsEffectifs.filter(d => ancienneConf.typeConviveId === d.typeConviveId && ancienneConf.structureMenuId === d.structureMenuId && ancienneConf.typeServiceId === d.typeServiceId && ancienneConf.typeRegimeId === d.typeRegimeId && ancienneConf.typeTextureId === d.typeTextureId)
      }
      if (!nouvelleConf) {
        // Suppression d'une configuration existante
        nouveauxEffectifs = detailsEffectifs.filter(d => nouvelleConf.typeConviveId === d.typeConviveId && nouvelleConf.structureMenuId === d.structureMenuId && nouvelleConf.typeServiceId === d.typeServiceId && nouvelleConf.typeRegimeId === d.typeRegimeId && nouvelleConf.typeTextureId === d.typeTextureId)
      }
      // if (!anciensEffectifs?.length) {

      // }
    },
    recapVersDetailsChangeJour(details, detailsOrigine, joursConsommation, recapEffectifs, jour, optionJour) {
      let nomJour = "effectifs" + (optionJour.nom ?? "")
      if (joursConsommation.find(j => j === jour)) {
        if (!details.some(d => d[nomJour])) {
          details.forEach(d => {
            let origine = detailsOrigine.find(o => o.id === d.id) ?? {}
            let effectifs = origine.find(o => o.id === d.id)[nomJour]
              ?? recapEffectifs.find(r => r.typeConviveId === d.typeConviveId && r.structureMenuId === d.structureMenuId && r.typeServiceId === d.typeServiceId && r.typeRegimeId === d.typeRegimeId && r.typeTextureId === d.typeTextureId)?.effectifs
            d[nomJour] = effectifs

            if (!d.joursConsommation.find(j => j === jour)) {
              d.joursConsommation.push(jour)
            }
          })
        }
      } else {
        details.forEach(d => {
          d[nomJour] = null
          if (d.joursConsommation.find(j => j === jour)) {
            _.remove(d.joursConsommation, j => j === jour)
          }
        })
      }
    },
    recapVersDetailsChangeJours(details, detailsOrigine, joursConsommation, recapEffectifs) {
      // Lundi
      if (joursConsommation.find(j => j === 1)) {
        if (!details.some(d => d.effectifsLundi)) {
          details.forEach(d => {
            let effectifs = detailsOrigine.find(o => o.id === d.id)?.effectifsLundi
              ?? recapEffectifs.find(r => r.typeConviveId === d.typeConviveId && r.structureMenuId === d.structureMenuId && r.typeServiceId === d.typeServiceId && r.typeRegimeId === d.typeRegimeId && r.typeTextureId === d.typeTextureId)?.effectifs
            d.effectifsLundi = effectifs
          })
        }
      } else {
        details.forEach(d => {
          d.effectifsLundi = null
        })
      }

      // Lundi
      if (joursConsommation.find(j => j === 1)) {
        if (!details.some(d => d.effectifsLundi)) {
          details.forEach(d => {
            let effectifs = detailsOrigine.find(o => o.id === d.id)?.effectifsLundi
              ?? recapEffectifs.find(r => r.typeConviveId === d.typeConviveId && r.structureMenuId === d.structureMenuId && r.typeServiceId === d.typeServiceId && r.typeRegimeId === d.typeRegimeId && r.typeTextureId === d.typeTextureId)?.effectifs
            d.effectifsLundi = effectifs
          })
        }
      } else {
        details.forEach(d => {
          d.effectifsLundi = null
        })
      }

      // Lundi
      if (joursConsommation.find(j => j === 1)) {
        if (!details.some(d => d.effectifsLundi)) {
          details.forEach(d => {
            let effectifs = detailsOrigine.find(o => o.id === d.id)?.effectifsLundi
              ?? recapEffectifs.find(r => r.typeConviveId === d.typeConviveId && r.structureMenuId === d.structureMenuId && r.typeServiceId === d.typeServiceId && r.typeRegimeId === d.typeRegimeId && r.typeTextureId === d.typeTextureId)?.effectifs
            d.effectifsLundi = effectifs
          })
        }
      } else {
        details.forEach(d => {
          d.effectifsLundi = null
        })
      }

      // Lundi
      if (joursConsommation.find(j => j === 1)) {
        if (!details.some(d => d.effectifsLundi)) {
          details.forEach(d => {
            let effectifs = detailsOrigine.find(o => o.id === d.id)?.effectifsLundi
              ?? recapEffectifs.find(r => r.typeConviveId === d.typeConviveId && r.structureMenuId === d.structureMenuId && r.typeServiceId === d.typeServiceId && r.typeRegimeId === d.typeRegimeId && r.typeTextureId === d.typeTextureId)?.effectifs
            d.effectifsLundi = effectifs
          })
        }
      } else {
        details.forEach(d => {
          d.effectifsLundi = null
        })
      }

      // Lundi
      if (joursConsommation.find(j => j === 1)) {
        if (!details.some(d => d.effectifsLundi)) {
          details.forEach(d => {
            let effectifs = detailsOrigine.find(o => o.id === d.id)?.effectifsLundi
              ?? recapEffectifs.find(r => r.typeConviveId === d.typeConviveId && r.structureMenuId === d.structureMenuId && r.typeServiceId === d.typeServiceId && r.typeRegimeId === d.typeRegimeId && r.typeTextureId === d.typeTextureId)?.effectifs
            d.effectifsLundi = effectifs
          })
        }
      } else {
        details.forEach(d => {
          d.effectifsLundi = null
        })
      }

      // Lundi
      if (joursConsommation.find(j => j === 1)) {
        if (!details.some(d => d.effectifsLundi)) {
          details.forEach(d => {
            let effectifs = detailsOrigine.find(o => o.id === d.id)?.effectifsLundi
              ?? recapEffectifs.find(r => r.typeConviveId === d.typeConviveId && r.structureMenuId === d.structureMenuId && r.typeServiceId === d.typeServiceId && r.typeRegimeId === d.typeRegimeId && r.typeTextureId === d.typeTextureId)?.effectifs
            d.effectifsLundi = effectifs
          })
        }
      } else {
        details.forEach(d => {
          d.effectifsLundi = null
        })
      }
/*
      <td v-if="joursConsommation.find(j => j === 1)" class="input">
        <InputNumber v-model="effectif.effectifsLundi" typeFiltre="quantiteEntiere" />
      </td>
      <td v-if="joursConsommation.find(j => j === 2)" class="input">
        <InputNumber v-model="effectif.effectifsMardi" typeFiltre="quantiteEntiere" />
      </td>
      <td v-if="joursConsommation.find(j => j === 3)" class="input">
        <InputNumber v-model="effectif.effectifsMercredi" typeFiltre="quantiteEntiere" />
      </td>
      <td v-if="joursConsommation.find(j => j === 4)" class="input">
        <InputNumber v-model="effectif.effectifsJeudi" typeFiltre="quantiteEntiere" />
      </td>
      <td v-if="joursConsommation.find(j => j === 5)" class="input">
        <InputNumber v-model="effectif.effectifsVendredi" typeFiltre="quantiteEntiere" />
      </td>
      <td v-if="joursConsommation.find(j => j === 6)" class="input">
        <InputNumber v-model="effectif.effectifsSamedi" typeFiltre="quantiteEntiere" />
      </td>
      <td v-if="joursConsommation.find(j => j === 0)" class="input">
        <InputNumber v-model="effectif.effectifsDimache" typeFiltre="quantiteEntiere" />
      </td>*/

    },
    // recapVersDetailsChangeJours(details, detailsOrigine, joursConsommation) {
    //   details.forEach(d => {
    //   })
    // },
    recapVersDetail(recap) {
      return
    }
  }
}
